/* eslint-disable no-unused-vars */
import React from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import section1Bg from '@/assets/finance/topic1100am/section1-bg.png';
import warningImg1 from '@/assets/finance/topic1100am/section1-img1.png';
import warningImg11 from '@/assets/finance/topic1100am/section1-img2.png';
import warningImg2 from '@/assets/finance/topic1100am/section1-img3.png';
import warningImg3 from '@/assets/finance/topic1100am/section1-img4.png';
import warningImg33 from '@/assets/finance/topic1100am/section1-img5.png';
import btnImg from '@/assets/finance/topic1100am/section1-arrow-down-circle.png';
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';

interface ISection3Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const updateComponentState = useUpdateComponentState();

  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';

  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );

  const [currentImage, setCurrentImage] = React.useState(0);
  const [isVisible, setIsVisible] = React.useState(true);

  const imagesList: any = {
    0: {
      src: warningImg1,
      src1: warningImg11,
    },
    1: {
      src: warningImg2,
      src1: null,
    },
    2: {
      src: warningImg3,
      src1: warningImg33,
    },
  };
  const warnings = React.useMemo(() => {
    return paragraphsSettings.warnings.map((item: any) => {
      return {
        ...item,
        imageSrc: imagesList[item.id].src,
        imageSrc1: imagesList[item.id].src1,
      };
    });
  }, []);

  const currentWarning = warnings[currentImage];

  return (
    <div className="topic-section-1 topic-section-1-en">
      <div className="title-container">
        <CTitle title={paragraphsSettings.header} />
      </div>
      <div className="triangle-container">
        <span className="triangle"></span> {paragraphsSettings.tips}
      </div>
      <div className="analytical-tool">
        <div className="analytical-tool-title">
          <span className="line"></span>
          <span className="circle"></span>
          <span>{paragraphsSettings.toolsTips}</span>
          <span className="circle"></span>
          <span className="line"></span>
        </div>

        <div className="tool-container">
          <div className="tool-cards">
            <img className="tool-cards-bg" src={section1Bg} alt="" />
            {paragraphsSettings.analyticalTools?.map((tool: any) => (
              <div key={tool.id} className="tool-card">
                <div className="tool-circle">
                  <div className="tool-icon">
                    <span className="tool-name">{tool.name}</span>
                  </div>
                </div>
                <div className="tool-description">{tool.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className="data-security-precautions"
        id="finance-topic1100-section1-1"
      >
        {isVisible && (
          <div className="data-security-precautions-arrow">
            <img src={ArrowImg} alt="" />
          </div>
        )}
        <div className="security-warning-container">
          {/* Image Carousel */}
          <div className="security-carousel">
            {/* Warning Image */}
            <div className="warning-image-container">
              {/* left */}
              <div className="speech-bubble">
                {currentWarning.speechBubbleText}
              </div>
              {/* right */}
              <div className="info-container">
                <div className="carousel-navigation">
                  <h3 className="carousel-title">{currentWarning.title}</h3>
                  <img
                    src={btnImg}
                    alt="next-button"
                    onClick={() =>
                      setCurrentImage((prev) => {
                        const nextIndex = (prev + 1) % 3;
                        if (nextIndex === 2) {
                          setIsVisible(false);
                          updateComponentState(
                            p_course,
                            p_topic,
                            ID,
                            'finance-topic1100-section1-1'
                          );
                        }
                        return nextIndex;
                      })
                    }
                  />
                </div>
                <div className="image-content">
                  <img
                    src={currentWarning.imageSrc}
                    alt={currentWarning.title}
                    className="warning-img"
                  />
                  {currentWarning.imageSrc1 ? (
                    <img
                      src={currentWarning.imageSrc1}
                      alt={currentWarning.title}
                      className="warning-img"
                    />
                  ) : null}
                </div>
              </div>
            </div>

            {/* Security Precautions */}
            <div className="security-precautions">
              <div className="security-precautions-title">
                {currentWarning.title}
              </div>
              <div className="precautions-grid">
                {currentWarning.precautions.map(
                  (precaution: string, index: number) => (
                    <div key={index} className="precaution-item">
                      <div className="number-container">
                        <span className="hexagon"></span>
                        <span className="number">{index + 1}</span>
                      </div>
                      <div className="precaution-text">{precaution}</div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
